/** @format */

/* eslint-disable */
import React from 'react'
import '../selectables.scss'
import Checkbox from '../../Checkbox/Checkbox'
import { PleaseWait } from '../../Loaders/PleaseWait'

function DirectDebits({
  disabled,
  isBusy,
  directDebitsToSelect,
  onCheckDirectDebit,
  prefix,
}) {
  const handleCheckDirectDebits = (directDebit, checkValue) => {
    const com = [...directDebitsToSelect].map(comm => {
      if (comm.id === directDebit.id) {
        return { ...comm, checked: checkValue }
      }
      return comm
    })

    onCheckDirectDebit(com)
  }

  return (
    <div className="px-4">
      {isBusy ? (
        <PleaseWait />
      ) : (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {directDebitsToSelect.map(directDebit => (
            <li
              key={directDebit.id}
              style={{ listStyle: 'none' }}
              className=" d-flex align-items-center"
            >
              <Checkbox
                id={`${prefix ? prefix : 'com'}-${directDebit.id}`}
                checked={directDebit.checked}
                disabled={disabled}
                margined
                onCheck={c => {
                  handleCheckDirectDebits(directDebit, c)
                }}
              />
              <label
                htmlFor={`${prefix ? prefix : 'com'}-${directDebit.id}`}
                className={`fw-normal ms-2 cursor-pointer ${
                  directDebit.checked ? 'text-primary fw-bold' : ''
                }`}
              >
                {directDebit.description}
              </label>
            </li>
          ))}
        </div>
      )}
    </div>
  )
}

export default DirectDebits
